export const getBasePath = (path, partsToRemove = 1) => {
  return path.split("/").slice(0, -partsToRemove).join("/")
}

export const getDisableFiltersAutosave = () => {
  const state = window.history.state
  return state?.state?.filters?.disableAutosave
}

export const isBoardView = (pathname) => {
  return pathname.includes("/board")
}
